import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField, { TextareaField } from '../../../../utils/InputField';
import { UrlValidate } from '../../../../utils/URL';
import { handleCreateProductOpe } from '../ProductOperation';
import { useProductSetting } from '../ProductSettingProvider';

function AddProductModal({ setCreateProductModal }) {
    const { setMessage } = useTemplate();
    const { setReloadKey } = useProductSetting();
    const [isError, setIsError] = useState(false);
    const [checkUrl, setCheckUrl] = useState({ logoUrl: '', websiteUrl: '' });
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ApplicationTitle: '',
        Description: '',
        Website: '',
        Status: 'active'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'LogoUrl') {
            setCheckUrl((d) => ({ ...d, logoUrl: value }));
        }
        if (name === 'Website') {
            setCheckUrl((d) => ({ ...d, websiteUrl: UrlValidate(value) }));
        }
        setFormData((d) => ({ ...d, [name]: value }));
    };

    const handleCreateCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        handleCreateProductOpe(formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                setCreateProductModal(false);
                setReloadKey((d) => d + 1);
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleCreateCustomer} className="flex flex-col gap-4">
            <InputField
                label="Application Title"
                name="ApplicationTitle"
                formData={formData}
                onChange={handleChange}
            />
            <TextareaField
                label="Description"
                name="Description"
                formData={formData}
                onChange={handleChange}
            />
            {/* Check website url check */}
            <div className="h-18 flex flex-col">
                <div className="w-full h-auto mb-2 flex flex-row justify-start items-center gap-x-2">
                    <span>Website Url</span>
                    {formData.Website ? (
                        <Link
                            to={checkUrl.websiteUrl || '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-warning/10 text-warning px-2 py-px rounded-md focus:outline focus:outline-1 focus:outline-primary-200"
                        >
                            Check
                        </Link>
                    ) : (
                        <span className="bg-warning/10 text-warning px-2 py-px rounded-md focus:outline focus:outline-1 focus:outline-primary-200 cursor-default">
                            Check
                        </span>
                    )}
                </div>
                <InputField
                    placeholder="https://www.exmple.com"
                    name="Website"
                    formData={formData}
                    onChange={handleChange}
                />
            </div>
            {/* Duration */}
            {/* <SelectOption
                label="Price Duration"
                name="PriceDuration"
                formData={formData}
                onChange={handleChange}
                height="h-16"
                options={priceDuration?.map((d) => addOption(d.key, d.title, d.key.toString()))}
            /> */}

            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => setCreateProductModal(false)} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default AddProductModal;
